<template>
  <div>
      <div class="echart" id="mychart" :style="myChartStyle"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  data() {
    return {
      xData: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], //横坐标
      yData: [23, 24, 18, 25, 27, 28, 25, 23, 24, 18, 25, 27, 28, 25], //数据
      myChartStyle: { width: "100%", height: "600px" } //图表样式
    };
  },
  mounted() {
    // if (window.location.href.indexOf('code') >= 0) {

    //   let code = window.location.href.split('?')[1];

    //   code = code.substring(5, code.indexOf('&'));
    //   console.log(code);
    // }
    this.getModelCountList();
  },
  methods: {
    initEcharts() {
      // 基本柱状图
      const option = {
        title: {
          text: '总体统计',
          left: '20',
          top: '20'
        },
        // 图例
        legend: {
          data: ["生产量"],
          top: "20"
        },
        xAxis: {
          data: this.xData,
          axisLabel: {
            interval: 0,
            rotate: 50,
          }
        },
        dataZoom: [
          {
            type: "inside",
            realtime: true,
            start: 0,
            end: 50,
            xAxisIndex: [0],
          },
        ],
        yAxis: {
          axisLabel: {
            formatter: '{value} 台'
          }
        },
        series: [
          {
            name: '生产量',
            type: "bar", //形状为柱状图
            data: this.yData
          }
        ]
      };
      const myChart = echarts.init(document.getElementById("mychart"));
      myChart.setOption(option);
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },

    getModelCountList(){
        this.$axios.get('/device_test/select_device_model_count_list',{
            params:{               //将URL地址拼接参数的形式换成传入params对象的形式
                token: 'lijian',
                customer: 'lijian',
                deviceType: '指纹头',
                testType: '指纹测试'
            }
        }).then(res=>{   //这里使用箭头函数的形式
            if(res.data.code==200){
                let xDataModel = [];
                let yDataCount = [];
                for(let i=0;i<res.data.data.length;i++){
                    xDataModel.push(res.data.data[i].deviceModel);
                    yDataCount.push(res.data.data[i].count);
                }
                this.xData = xDataModel;
                this.yData = yDataCount;
                this.initEcharts();
            }else{
                this.$message({
                    message: res.data.msg,
                    type: "error",
                    showClose: true,
                });
            }
        })        
    }


  }
};
</script>


// WEBPACK FOOTER //
// src/components/views/ModelTotal.vue